import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavItem {
  label: string;
  href: string;
  hasDropdown?: boolean;
  subItems?: { label: string; href: string }[];
}

const navItems: NavItem[] = [
  { label: 'Inicio', href: '/' },
  {
    label: 'Perros',
    href: '/perros',
    hasDropdown: true,
    subItems: [
      { label: 'Alimentos', href: '/perros/alimentos' },
      { label: 'Snacks', href: '/perros/snacks' },
      { label: 'Juguetes', href: '/perros/juguetes' },
      { label: 'Camas y Casas', href: '/perros/camas' },
      { label: 'Higiene', href: '/perros/higiene' },
      { label: 'Accesorios', href: '/perros/accesorios' },
    ],
  },
  {
    label: 'Gatos',
    href: '/gatos',
    hasDropdown: true,
    subItems: [
      { label: 'Alimentos', href: '/gatos/alimentos' },
      { label: 'Snacks', href: '/gatos/snacks' },
      { label: 'Juguetes', href: '/gatos/juguetes' },
      { label: 'Areneros', href: '/gatos/areneros' },
      { label: 'Rascadores', href: '/gatos/rascadores' },
      { label: 'Accesorios', href: '/gatos/accesorios' },
    ],
  },
  {
    label: 'Prendas',
    href: '/prendas',
    hasDropdown: true,
    subItems: [
      { label: 'Ropa para Perros', href: '/prendas/perros' },
      { label: 'Ropa para Gatos', href: '/prendas/gatos' },
      { label: 'Disfraces', href: '/prendas/disfraces' },
    ],
  },
  {
    label: 'Placas',
    href: '/placas',
    hasDropdown: true,
    subItems: [
      { label: 'Placas Personalizadas', href: '/placas/personalizadas' },
      { label: 'Placas con QR', href: '/placas/qr' },
    ],
  },
  { label: 'Farmacia', href: '/farmacia' },
  { label: 'Outlet', href: '/outlet' },
  { label: 'Blog', href: '/blog' },
];

export function Navigation() {
  const location = useLocation();
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);

  return (
    <nav className="hidden md:block bg-primary">
      <div className="container">
        <ul className="flex items-center justify-center">
          {navItems.map((item) => {
            const isActive =
              location.pathname === item.href ||
              location.pathname.startsWith(item.href + '/');

            return (
              <li
                key={item.href}
                className="relative"
                onMouseEnter={() => item.hasDropdown && setOpenDropdown(item.href)}
                onMouseLeave={() => setOpenDropdown(null)}
              >
                <Link
                  to={item.href}
                  className={`
                    flex items-center gap-1 px-4 py-3 text-sm font-medium transition-colors
                    ${isActive ? 'text-white bg-white/10' : 'text-white/90 hover:text-white hover:bg-white/10'}
                  `}
                >
                  <span>{item.label}</span>
                  {item.hasDropdown && (
                    <ChevronDownIcon className="w-4 h-4" />
                  )}
                </Link>

                {/* Dropdown menu */}
                {item.hasDropdown && item.subItems && openDropdown === item.href && (
                  <div className="absolute top-full left-0 bg-white shadow-lg rounded-b-lg min-w-[200px] py-2 z-50">
                    {item.subItems.map((subItem) => (
                      <Link
                        key={subItem.href}
                        to={subItem.href}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary/10 hover:text-primary transition-colors"
                      >
                        {subItem.label}
                      </Link>
                    ))}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
}

function ChevronDownIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  );
}
